import { useCallback, useRef } from 'react';

const isOutside = (element, container) => {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return elementRect.top < containerRect.top
    || elementRect.bottom > containerRect.bottom
    || elementRect.left < containerRect.left
    || elementRect.right > containerRect.right;
};

export function useDoctorListNavigation(onSelect) {
  const listRef = useRef(null);
  const doctorElements = useRef(new Map());

  const registerDoctor = useCallback((doctorId) => (element) => {
    const key = String(doctorId);
    if (element) doctorElements.current.set(key, element);
    else doctorElements.current.delete(key);
  }, []);

  const selectDoctorFromMap = useCallback((doctor) => {
    onSelect(doctor);

    const doctorElement = doctorElements.current.get(String(doctor.id));
    if (doctorElement && listRef.current && isOutside(doctorElement, listRef.current)) {
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      doctorElement.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    }
  }, [onSelect]);

  return { listRef, registerDoctor, selectDoctorFromMap };
}

export default useDoctorListNavigation;
